<template>
  <div v-if="googleReady" class="google-login-btn text-center">
    <div id="g_btn_wrap"
         data-type="standard"
         data-shape="rectangular"
         data-theme="outline"
         data-text="signin_with"
         data-size="large"
         data-logo_alignment="left">
    </div>
    <div class="loading" v-if="loading">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>
<script>
import googleService from "../Services/GoogleService";

const {EventBus} = require("../Bus.js");

let service = new googleService();

export default {
  data() {
    return {
      loading: false,
      googleReady: false,
    }
  },

  mounted() {
    service.loadGapi().then((auth) => {
      console.log(`google client ready`);
      console.log(auth);
      this.googleReady = true;
      this.$nextTick(() => {
        const wrapper = document.querySelector('#g_btn_wrap');
        service.init(wrapper).then(this.handleSignIn);
      })
    })
  },

  methods: {
    handleSignIn(json) {
      this.loading = true;
      service.signIn(json)
          .then((token) => {
            EventBus.dispatchUserLogin();
            const ref = this.$route.query.ref || null;
            if (ref) {
              this.$router.push({
                path: ref
              });
              return;
            }
            this.$router.push({
              path: '/'
            });
          })
      .finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>
<style lang="scss">
.google-login-btn {
  .loading {
    left: 0;
    top: 0;
    display: flex;
    position: fixed;
    z-index: 10;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);

    justify-content: center;
    align-items: center;
  }
}

</style>
